var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { properties, showOffMarketCta, ctaText } = options; 
__p+='\n';
 if(properties) { 
__p+='\n  ';
 if(properties.length > 1) {  
__p+='\n    <div class="rdc-carousel" id="homes_nearby_card_carousel">\n      <div class="owl-carousel">\n        ';
 properties.forEach((property) => { 
__p+='\n          '+
((__t=( JST["templates/homes_around_card"]({ property: property, showOffMarketCta, ctaText}) ))==null?'':__t)+
'\n        ';
 }) 
__p+='\n      </div>\n    <div class="rdc-carousel-nav">\n        <div class="rdc-prev-set hide"><i class="ra ra-angle-left"></i></div>\n        <div class="rdc-next-set hide"><i class="ra ra-angle-right"></i></div>\n      </div>\n    </div>\n  ';
 } else { 
__p+='\n    '+
((__t=( JST["templates/homes_around_card"]({property: properties, showOffMarketCta, ctaText}) ))==null?'':__t)+
'\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/homes_around_card_carousel.jst.ejs